import axios from "axios";

// 区分系统获取项目授权信息
export function getXmsqinfo(data) {
  return axios({
    url: "/api/sqgl/getXmsqinfo",
    method: "post",
    data: data,
  });
}
// 不区分系统获取项目授权信息
export function getXmsqinfo2(data) {
  return axios({
    url: "/api/sqgl/getXmsqinfo2",
    method: "post",
    data: data,
  });
}
// 获取已授权信息
export function getYsqxm(data) {
  return axios({
    url: "/api/sqgl/getYsqxm",
    method: "post",
    data: data,
  });
}
// 被授权人信息
export function getUserinfo(data) {
  return axios({
    url: "/api/sqgl/getUserinfo",
    method: "post",
    data: data,
  });
}
// 授权操作
export function spOperates(data) {
  return axios({
    url: "/api/sqgl/spoperates",
    method: "post",
    data: data,
  });
}

// 授权操作,不区分系统
export function spOperatess(data) {
  return axios({
    url: "/api/sqgl/spoperatess",
    method: "post",
    data: data,
  });
}

// 获取当前用户授权项目
export function getQxxmsq(param) {
  return axios({
    url: "/api/sqgl/cxsqxm",
    method: "post",
    data: param,
  });
}

// 取消项目授权
export function cancelProject(param) {
  return axios({
    url: "/api/sqgl/qxxmsq",
    method: "post",
    data: param,
  });
}

// 批量取消项目授权
export function cancelProjects(param) {
  return axios({
    url: "/api/sqgl/plqxxmsq",
    method: "post",
    data: param,
  });
}

//   获取当前用户授权项目
export function getAllSqxmLog(param) {
  return axios({
    url: "/api/sqgl/cxsqje",
    method: "post",
    data: param,
  });
}

// 取消授权金额
export function removeJe(param) {
  return axios({
    url: "/api/sqgl/qxsqje",
    method: "post",
    data: param,
  });
}

// 批量取消授权金额
export function removeJes(param) {
  return axios({
    url: "/api/sqgl/plqxsqje",
    method: "post",
    data: param,
  });
}

// 获取当前人员已授权的所有项目log(授权日志一览用)
export function getAllSqLog(param) {
  return axios({
    url: "/api/sqgl/allsqlog",
    method: "post",
    data: param,
  });
}

// 根据授权人获取已被授权的所有项目log
export function getSqLogBySqr(param) {
  return axios({
    url: "/api/sqgl/sqlogbysqr",
    method: "post",
    data: param,
  });
}

// 根据授权人获取已被授权的所有项目log
export function getBsqInfo(param) {
  return axios({
    url: "/api/sqgl/bsqinfo",
    method: "post",
    data: param,
  });
}

// 根据授权人获取已被授权的所有项目log
export function getBsqlogInfo(param) {
  return axios({
    url: "/api/sqgl/bsqloginfo",
    method: "post",
    data: param,
  });
}

// 获取jqxTree数据（部门，项目）
export function getBmXmTreeData(param) {
  return axios({
    url: "/api/sqgl/bmxmtreedata",
    method: "post",
    data: param,
  });
}

// 根据项目编号或部门编号获取授权信息
export function getSqxx(param) {
  return axios({
    url: "/api/sqgl/sqxx",
    method: "post",
    data: param,
  });
}

// 获取负责人所有部门的所有项目授权信息(申报系统)
export function getSbSyxxByBsqr(param) {
  return axios({
    url: "/api/sqgl/sbsyxx",
    method: "post",
    data: param,
  });
}

// 获取负责人所有部门的所有项目授权信息(报销系统)
export function getBxSyxxByBsqr(param) {
  return axios({
    url: "/api/sqgl/bxsyxx",
    method: "post",
    data: param,
  });
}

// 获取授权项目的使用信息(申报系统)
export function getXmSyxxSb(param) {
  return axios({
    url: "/api/sqgl/txmsyxxsb",
    method: "post",
    data: param,
  });
}

// 获取授权项目的使用信息(网报系统)
export function getXmSyxxBx(param) {
  return axios({
    url: "/api/sqgl/xmsyxxbx",
    method: "post",
    data: param,
  });
}

// 获取我的项目模块我负责的项目数据
export function getWfzdxm(param) {
  return axios({
    url: "/api/sqgl/wfzdxm",
    method: "post",
    data: param,
  });
}

// 根据授权人获取已授权的项目统计
export function getDisQxxmsq(param) {
  return axios({
    url: "/api/sqgl/discxsqxm",
    method: "post",
    data: param,
  });
}

// 根据授权人获取已被授权的项目统计
export function getDisBsqInfo(param) {
  return axios({
    url: "/api/sqgl/disbsqinfo",
    method: "post",
    data: param,
  });
}

// 根据项目负责人查询项目
export function getXmByFzr(param) {
  return axios({
    url: "/api/sqgl/xmbyfzr",
    method: "post",
    data: param,
  });
}

// 申请授权
export function toApplyPower(param) {
  return axios({
    url: "/api/sqgl/sqsq",
    method: "post",
    data: param,
  });
}

// 获取登录人申请授权的记录
export function getXmsqSqBySqr() {
  return axios({
    url: "/api/sqgl/sqsqjl",
    method: "get",
  });
}

// 根据登录人负责的项目获取授权申请信息
export function getXmsqSq() {
  return axios({
    url: "/api/sqgl/xmsqsq",
    method: "get",
  });
}

// 审核管理
export function approvalApply(param) {
  return axios({
    url: "/api/sqgl/sqsqsh",
    method: "post",
    data: param,
  });
}

// 判断用户是否是部门负责人
export function getIsBmfzr() {
  return axios({
    url: "/api/sqgl/isbmfzr",
    method: "get",
  });
}

// 审核管理
export function getSignatureProject(param) {
  return axios({
    url: "/api/sqgl/signatureproject",
    method: "post",
    data: param,
  });
}

// 项目签批授权
export function signAuthorization(param) {
  return axios({
    url: "/api/sqgl/signauthorization",
    method: "post",
    data: param,
  });
}

// 被授权人变更
export function changeAuthorized(param) {
  return axios({
    url: "/api/sqgl/changeauthorized",
    method: "post",
    data: param,
  });
}

// 项目编号变更
export function changeProject(param) {
  return axios({
    url: "/api/sqgl/changeproject",
    method: "post",
    data: param,
  });
}

// 数据变更申请
export function changeProjectAudit(param) {
  return axios({
    url: "/api/sqgl/changeprojectaudit",
    method: "post",
    data: param,
  });
}

// 获取数据变更申请
export function getSjbgsq(param) {
  return axios({
    url: "/api/sqgl/getsjbgsq",
    method: "get",
  });
}

// 获取数据变更申请
export function getMySjbgsq(param) {
  return axios({
    url: "/api/sqgl/getmysjbgsq",
    method: "get",
  });
}

// 数据变更申请审核
export function sjbgsqsh(param) {
  return axios({
    url: "/api/sqgl/sjbgsqsh",
    method: "post",
    data: param,
  });
}

// 获取负责人项目
export function getFzrXm() {
  return axios({
    url: "/api/sqgl/getFzrXm",
    method: "get",
  });
}

// 修改项目是否开启短信提醒
export function setXmisdx(param) {
  return axios({
    url: "/api/sqgl/setxmisdx",
    method: "post",
    data: param,
  });
}

// 修改项目授权起止时间
export function setSqqzrq(param) {
  return axios({
    url: "/api/sqgl/setsqqzrq",
    method: "post",
    data: param,
  });
}

// 根据项目负责人查询被授权人和项目
export function getBsqrAndXmByFzr(param) {
  return axios({
    url: "/api/sqgl/bsqrandxmbyfzr",
    method: "post",
    data: param,
  });
}